// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      display: block;
      font-family: 'DM Sans', 'Segoe UI', sans-serif;
    }

    /* ── Header shell ── */
    .app-header {
      position: sticky;
      top: 0;
      z-index: 100;
      background: #ffffff;
      border-bottom: 1.5px solid #f0eafa;
      box-shadow: 0 2px 20px rgba(109, 40, 217, 0.06);
    }

    /* ── Main layout ── */
    .header-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 80px;
      padding: 0 2rem;
      max-width: 1920px;
      margin: 0 auto;
    }

    /* ── Left group ── */
    .header-left {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      flex: 1;
      min-width: 0; /* Allow flex items to shrink */
    }



    /* ── User section ── */
    .header-user {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0; /* Allow content to shrink properly */
    }

    /* ── Right side logo ── */
    .header-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex-shrink: 0;
      padding-left: 2rem;
    }

    .header-logo {
      height: 44px;
      width: auto;
      object-fit: contain;
    }



    /* ── Color overrides for user-info ── */
    :host ::ng-deep .text-white,
    :host ::ng-deep .text-light {
      color: #1a003d !important;
    }

    :host ::ng-deep small.font-weight-light,
    :host ::ng-deep small {
      color: #9ca3af !important;
    }

    :host ::ng-deep .vr.bg-white {
      background: #e5e7eb !important;
    }

    :host ::ng-deep ng-icon.text-white {
      color: #7c3aed !important;
    }

    :host ::ng-deep .btn-outline-light {
      border-color: #ede9fb !important;
      color: #374151 !important;
      background: #faf8ff !important;
    }

    :host ::ng-deep .btn-outline-light:hover {
      background: #f3eeff !important;
      border-color: #c4b5fd !important;
      color: #7c3aed !important;
    }

    :host ::ng-deep .mobile-menu {
      right: 1rem;
      top: calc(100% + 4px);
      background: #ffffff;
      border: 1.5px solid #f0eafa;
      box-shadow: 0 8px 32px rgba(109, 40, 217, 0.12);
      border-radius: 12px;
    }

    /* ── Mobile Responsive ── */
    @media (max-width: 1280px) {
      .header-inner {
        padding: 0 1.5rem;
      }

      .header-left {
        gap: 1.25rem;
      }

      .header-right {
        padding-left: 1.5rem;
      }

      .header-logo {
        height: 40px;
      }
    }

    @media (max-width: 1024px) {
      .header-inner {
        padding: 0 1.25rem;
        height: 76px;
      }

      .header-left {
        gap: 1rem;
      }

      .header-right {
        padding-left: 1.25rem;
      }
    }

    @media (max-width: 768px) {
      .header-inner {
        padding: 0 1rem;
        height: 72px;
      }

      .header-left {
        gap: 0.875rem;
      }

      .header-accent-bar {
        width: 36px;
        height: 4px;
      }

      .header-right {
        padding-left: 1rem;
      }

      .header-logo {
        height: 36px;
      }
    }

    @media (max-width: 480px) {
      .header-inner {
        padding: 0 0.75rem;
        height: 68px;
      }

      .header-left {
        gap: 0.75rem;
      }

      .header-accent-bar {
        width: 32px;
      }

      .header-right {
        padding-left: 0.75rem;
      }

      .header-logo {
        height: 32px;
      }
    }
  `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/sections/zikata-header/zikata-header.component.ts"],"names":[],"mappings":";IACI;MACE,cAAc;MACd,8CAA8C;IAChD;;IAEA,uBAAuB;IACvB;MACE,gBAAgB;MAChB,MAAM;MACN,YAAY;MACZ,mBAAmB;MACnB,kCAAkC;MAClC,+CAA+C;IACjD;;IAEA,sBAAsB;IACtB;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,eAAe;MACf,iBAAiB;MACjB,cAAc;IAChB;;IAEA,qBAAqB;IACrB;MACE,aAAa;MACb,mBAAmB;MACnB,WAAW;MACX,OAAO;MACP,YAAY,EAAE,+BAA+B;IAC/C;;;;IAIA,uBAAuB;IACvB;MACE,aAAa;MACb,mBAAmB;MACnB,OAAO;MACP,YAAY,EAAE,qCAAqC;IACrD;;IAEA,0BAA0B;IAC1B;MACE,aAAa;MACb,mBAAmB;MACnB,yBAAyB;MACzB,cAAc;MACd,kBAAkB;IACpB;;IAEA;MACE,YAAY;MACZ,WAAW;MACX,mBAAmB;IACrB;;;;IAIA,wCAAwC;IACxC;;MAEE,yBAAyB;IAC3B;;IAEA;;MAEE,yBAAyB;IAC3B;;IAEA;MACE,8BAA8B;IAChC;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,gCAAgC;MAChC,yBAAyB;MACzB,8BAA8B;IAChC;;IAEA;MACE,8BAA8B;MAC9B,gCAAgC;MAChC,yBAAyB;IAC3B;;IAEA;MACE,WAAW;MACX,qBAAqB;MACrB,mBAAmB;MACnB,2BAA2B;MAC3B,+CAA+C;MAC/C,mBAAmB;IACrB;;IAEA,4BAA4B;IAC5B;MACE;QACE,iBAAiB;MACnB;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,oBAAoB;MACtB;;MAEA;QACE,YAAY;MACd;IACF;;IAEA;MACE;QACE,kBAAkB;QAClB,YAAY;MACd;;MAEA;QACE,SAAS;MACX;;MAEA;QACE,qBAAqB;MACvB;IACF;;IAEA;MACE;QACE,eAAe;QACf,YAAY;MACd;;MAEA;QACE,aAAa;MACf;;MAEA;QACE,WAAW;QACX,WAAW;MACb;;MAEA;QACE,kBAAkB;MACpB;;MAEA;QACE,YAAY;MACd;IACF;;IAEA;MACE;QACE,kBAAkB;QAClB,YAAY;MACd;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,WAAW;MACb;;MAEA;QACE,qBAAqB;MACvB;;MAEA;QACE,YAAY;MACd;IACF","sourcesContent":["\n    :host {\n      display: block;\n      font-family: 'DM Sans', 'Segoe UI', sans-serif;\n    }\n\n    /* ── Header shell ── */\n    .app-header {\n      position: sticky;\n      top: 0;\n      z-index: 100;\n      background: #ffffff;\n      border-bottom: 1.5px solid #f0eafa;\n      box-shadow: 0 2px 20px rgba(109, 40, 217, 0.06);\n    }\n\n    /* ── Main layout ── */\n    .header-inner {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      height: 80px;\n      padding: 0 2rem;\n      max-width: 1920px;\n      margin: 0 auto;\n    }\n\n    /* ── Left group ── */\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 1.5rem;\n      flex: 1;\n      min-width: 0; /* Allow flex items to shrink */\n    }\n\n\n\n    /* ── User section ── */\n    .header-user {\n      display: flex;\n      align-items: center;\n      flex: 1;\n      min-width: 0; /* Allow content to shrink properly */\n    }\n\n    /* ── Right side logo ── */\n    .header-right {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      flex-shrink: 0;\n      padding-left: 2rem;\n    }\n\n    .header-logo {\n      height: 44px;\n      width: auto;\n      object-fit: contain;\n    }\n\n\n\n    /* ── Color overrides for user-info ── */\n    :host ::ng-deep .text-white,\n    :host ::ng-deep .text-light {\n      color: #1a003d !important;\n    }\n\n    :host ::ng-deep small.font-weight-light,\n    :host ::ng-deep small {\n      color: #9ca3af !important;\n    }\n\n    :host ::ng-deep .vr.bg-white {\n      background: #e5e7eb !important;\n    }\n\n    :host ::ng-deep ng-icon.text-white {\n      color: #7c3aed !important;\n    }\n\n    :host ::ng-deep .btn-outline-light {\n      border-color: #ede9fb !important;\n      color: #374151 !important;\n      background: #faf8ff !important;\n    }\n\n    :host ::ng-deep .btn-outline-light:hover {\n      background: #f3eeff !important;\n      border-color: #c4b5fd !important;\n      color: #7c3aed !important;\n    }\n\n    :host ::ng-deep .mobile-menu {\n      right: 1rem;\n      top: calc(100% + 4px);\n      background: #ffffff;\n      border: 1.5px solid #f0eafa;\n      box-shadow: 0 8px 32px rgba(109, 40, 217, 0.12);\n      border-radius: 12px;\n    }\n\n    /* ── Mobile Responsive ── */\n    @media (max-width: 1280px) {\n      .header-inner {\n        padding: 0 1.5rem;\n      }\n\n      .header-left {\n        gap: 1.25rem;\n      }\n\n      .header-right {\n        padding-left: 1.5rem;\n      }\n\n      .header-logo {\n        height: 40px;\n      }\n    }\n\n    @media (max-width: 1024px) {\n      .header-inner {\n        padding: 0 1.25rem;\n        height: 76px;\n      }\n\n      .header-left {\n        gap: 1rem;\n      }\n\n      .header-right {\n        padding-left: 1.25rem;\n      }\n    }\n\n    @media (max-width: 768px) {\n      .header-inner {\n        padding: 0 1rem;\n        height: 72px;\n      }\n\n      .header-left {\n        gap: 0.875rem;\n      }\n\n      .header-accent-bar {\n        width: 36px;\n        height: 4px;\n      }\n\n      .header-right {\n        padding-left: 1rem;\n      }\n\n      .header-logo {\n        height: 36px;\n      }\n    }\n\n    @media (max-width: 480px) {\n      .header-inner {\n        padding: 0 0.75rem;\n        height: 68px;\n      }\n\n      .header-left {\n        gap: 0.75rem;\n      }\n\n      .header-accent-bar {\n        width: 32px;\n      }\n\n      .header-right {\n        padding-left: 0.75rem;\n      }\n\n      .header-logo {\n        height: 32px;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
